import { Route } from '@angular/router';
import { RoutePath } from '@univacity/shared/types';

export const dashboardToursRoutes: Route[] = [
  {
    path: RoutePath.create,
    loadComponent: () =>
      import('./tour-form/tour-form.component').then(
        (m) => m.TourFormComponent
      ),
  },
  {
    path: `:id/${RoutePath.edit}`,
    loadComponent: () =>
      import('./tour-form/tour-form.component').then(
        (m) => m.TourFormComponent
      ),
  },
  {
    path: `${RoutePath.bookings}`,
    loadComponent: () =>
      import('./tour-booking-list-page/tour-booking-list-page.component').then(
        (m) => m.TourBookingListPageComponent
      ),
  },
];
